import * as React from "react"
const SvgUpload = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 20.571q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18.57v-2a.97.97 0 0 1 .287-.712A.97.97 0 0 1 5 15.57a.97.97 0 0 1 .713.288q.287.289.287.712v2h12v-2q0-.424.288-.712A.97.97 0 0 1 19 15.57q.424 0 .712.288.288.289.288.712v2a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 18 20.57H6Zm5-12.15-1.875 1.875a.93.93 0 0 1-.713.288 1.02 1.02 0 0 1-.712-.313q-.275-.3-.288-.7a.92.92 0 0 1 .288-.7l3.6-3.6q.15-.15.325-.212.175-.063.375-.063c.2 0 .258.021.375.063a.9.9 0 0 1 .325.212l3.6 3.6q.3.3.287.7a1.02 1.02 0 0 1-1 1.012.93.93 0 0 1-.712-.287L13 8.421v7.15a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713z" />
  </svg>
)
export default SvgUpload
